export const MAX_PRICE = 49999999;
